import { Box, Button, TextField, Typography } from "@mui/material";
import NotesList from "./NotesList";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { useEffect, useState } from "react";
import { useNotes } from "../context/NotesContext";
import { v4 as uuidv4 } from "uuid";
import { useNavigate } from "react-router-dom";

export default function Notes() {
    const { notes, setNotes, cleanNotes } = useNotes();
    const [searchQuery, setSearchQuery] = useState("");

    const filteredNotes = notes.filter(
        (note) =>
            note.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
            note.note.toLowerCase().includes(searchQuery.toLowerCase())
    );

    useEffect(() => {
        cleanNotes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const navigate = useNavigate();

    const handleOpenBoard = (id = null) => {
        let noteToEdit;

        if (!id) {
            noteToEdit = {
                id: uuidv4(),
                title: "",
                note: "",
                created_at: new Date().toISOString(),
            };
            setNotes([...notes, noteToEdit]);

            navigate("/board", {
                state: { id: noteToEdit.id, isNewNote: true },
            });
        } else {
            noteToEdit = notes.find((n) => n.id === id);

            navigate("/board", {
                state: { id: noteToEdit.id, isNewNote: false },
            });
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                width: "100%",
                marginTop: "30px",
                textAlign: "center",
                padding: "10px 0 100px",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "15px",
                }}
            >
                <Typography
                    color="text.primary"
                    variant="h4"
                    sx={{ userSelect: "none" }}
                >
                    Your Notes
                </Typography>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => handleOpenBoard(null)}
                    endIcon={<AddRoundedIcon />}
                >
                    New Note
                </Button>
            </Box>

            <TextField
                variant="outlined"
                placeholder="Search notes..."
                value={searchQuery}
                autoComplete="off"
                onChange={(e) => setSearchQuery(e.target.value)}
                fullWidth
                size="small"
                sx={{
                    marginBottom: 2,
                    bgcolor: "background.paper",
                    borderRadius: "12px",
                }}
                InputProps={{
                    sx: { borderRadius: "12px" },
                }}
            />

            {notes.length === 0 ? (
                <Typography
                    color="text.secondary"
                    sx={{
                        textAlign: "center",
                        padding: 4,
                        fontStyle: "italic",
                    }}
                >
                    No notes yet. Click "New Note" to add your first note!
                </Typography>
            ) : filteredNotes.length === 0 ? (
                <Typography
                    color="text.secondary"
                    sx={{
                        textAlign: "center",
                        padding: 4,
                        fontStyle: "italic",
                    }}
                >
                    No matching notes found for your search.
                </Typography>
            ) : (
                <NotesList
                    notes={filteredNotes}
                    handleOpenBoard={(id) => handleOpenBoard(id)}
                />
            )}
        </Box>
    );
}
